import React from 'react';
import { LargeCarousel } from 'scy/Carousel';
import styles from 'scy/Carousel/styles.mod.scss';
import GridItem from './GridItem';

export default function Carousel({ products, sliderSettings, trackCategory }) {
  return (
    <LargeCarousel {...sliderSettings}>
      {products.map(product => (
        <div className={styles.productImageContainer} key={product.sku_id}>
          <GridItem
            product={product}
            trackCategory={trackCategory}
            includeItemProps
            className={styles.productImage}
          />
        </div>
      ))}
    </LargeCarousel>
  );
}
